import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {apiRequest} from "../../utils/AxiosHelper";
import APIs from "../../modules/settings/APIs";

export type IssueFilterCriteria = {
  searchText?: string;

  status?: string;
  impact?: string;
  origin?: string;
  effect?: string;
  options?: {};
  createdDateFrom?: string;
  createdDateTo?: string;
  closedDateFrom?: string;
  closedDateTo?: string;

  offset?: number;
  limit?: number;
  skipAggregation?: boolean;
}


const filterIssues = async (criteria: IssueFilterCriteria) => {
  const response = await apiRequest.post(APIs.filter.issues.search, criteria);

  // Return the complete response which should include both data and aggregations
  return response.data;
};

export const useFilterIssue = (
  criteria: IssueFilterCriteria,
  options?: { enabled?: boolean }
) => {

  return useQuery({
    queryKey: ['searchIssues', criteria],
    queryFn: () => filterIssues(criteria),
    // When enabled, the reactive queryKey drives fetching/refetching as the
    // criteria change — no manual refetch() from an effect needed. Callers that
    // still drive fetching imperatively (e.g. HeaderSearchModal) omit it.
    enabled: options?.enabled ?? false,
    placeholderData: keepPreviousData, // hold the previous page while the next loads
    staleTime: 2 * 60 * 1000, // 2 minutes
    retry: 2,
  });
};
